/* eslint-disable no-param-reassign */
import React from 'react';

import { ExternalLink } from '../../ExternalLink';
import { InternalLink } from '../../InternalLink';

interface Props {
  href: string;
}

export const CustomLink: React.FC<Props> = ({ href, children, ...props }) => {
  const internal = /^[^/]+\/[^/].*$|^\/[^/].*$/.test(href);
  const file = /\.[0-9a-z]+$/i.test(href);

  if (internal && !file) {
    return (
      <InternalLink {...props} to={href}>
        {children}
      </InternalLink>
    );
  }

  return (
    <ExternalLink {...props} href={href}>
      {children}
    </ExternalLink>
  );
};
